/**
 * Norbu Buddhist Handicraft — Site Settings
 * Placeholder values — replace with verified information before launch
 */

import type { SiteSettings } from './types';

export const SITE_SETTINGS: SiteSettings = {
  id: 'site-settings',
  storeName: 'Norbu Buddhist Handicraft',
  tagline: 'Traditional Art. Timeless Elegance.',
  contactEmail: '[BUSINESS_EMAIL]',
  phone: '[BUSINESS_PHONE]',
  whatsappE164: '[WHATSAPP_E164]',
  address: '[STORE_STREET_ADDRESS], [CITY_NEPAL]',
  mapsUrl: '[GOOGLE_MAPS_URL]',
  openingHours: '[OPENING_HOURS]',
  instagramUrl: '[INSTAGRAM_URL]',
  facebookUrl: '[FACEBOOK_URL]',
  updatedAt: new Date().toISOString(),
};